import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Campaign } from '../../../../../model/campaign/Campaign';
import EmptyState from '../../../../../shared/components/placeholder/EmptyState';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { UserRoles } from '../../../../../enum/UserRoles';
import { IOfferWithCampaign } from '../../../profile/profile-view';
import CardViewOffer from '../desktop/CardViewOffer';
import { Col, Row } from 'react-bootstrap';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { CardViewOfferSkeleton } from '../InfluencerDashboardSkeletons';

const SKELETON_COUNT = 3;

interface Props {
    campaigns?: Campaign[];
    offers?: IOfferWithCampaign[];
    hasContracts?: boolean;
    isLoading?: boolean;
}

const MyCampaigns = ({ offers, hasContracts = false, isLoading = false }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        user: { userType },
    } = useSelector((state: IAllStates) => state.auth);
    const { selectedInfluencer } = useSelector((state: IAllStates) => state.agency);
    const isAgency = [UserRoles.AGENCY, UserRoles.AGENCY_MASTER].includes(userType as UserRoles);

    const navigateToMyCampaigns = () => {
        isAgency ? navigate('/agency/campaigns') : navigate('/influencer/campaigns');
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between">
                {selectedInfluencer?.id ? (
                    <h4>{t('influencer.dashboard.campaigns_from', { firstName: selectedInfluencer?.firstName })}</h4>
                ) : (
                    <h4>{t('influencer.dashboard.yourCampaigns')}</h4>
                )}
                {!hasContracts && (
                    <p onClick={navigateToMyCampaigns} className="text-uppercase text-muted text-underline mb-0">
                        {t('influencer.header.myCampaigns')}
                    </p>
                )}
            </div>
            {isLoading ? (
                <Row aria-hidden="true">
                    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                        <Col key={i} className="my-2 col-12">
                            <CardViewOfferSkeleton />
                        </Col>
                    ))}
                </Row>
            ) : !!offers?.length ? (
                <Row>
                    {offers.map(item => (
                        <Col className="my-2 col-12" key={item?.id}>
                            <CardViewOffer offer={item} />
                        </Col>
                    ))}
                </Row>
            ) : (
                <CardLayout classCard="mt-2">
                    <EmptyState
                        navigateTo={isAgency ? '/agency/explore' : '/influencer/explore'}
                        btnText={t('general.tabs.explore')}
                    />
                </CardLayout>
            )}
        </>
    );
};

export default MyCampaigns;
